export enum EProjectSettingsPage {
  GENERAL = 'general',
  SERVICES = 'services',
}
